import { render, staticRenderFns } from "./anatomy.vue?vue&type=template&id=09976fb8&"
import script from "./anatomy.vue?vue&type=script&lang=js&"
export * from "./anatomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports